import { render, staticRenderFns } from "./ModalSuporteDeFinxParaHis.vue?vue&type=template&id=d22e4b44&scoped=true"
import script from "./ModalSuporteDeFinxParaHis.vue?vue&type=script&lang=ts"
export * from "./ModalSuporteDeFinxParaHis.vue?vue&type=script&lang=ts"
import style0 from "./ModalSuporteDeFinxParaHis.vue?vue&type=style&index=0&id=d22e4b44&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d22e4b44",
  null
  
)

export default component.exports